export const PERMISSION_CATEGORIES = [
  "partners",
  "templates",
  "tasks",
  "objectOverviews",
  "forms",
  "submissions",
  "commissionPlans",
  "commissionStatements",
  "assets",
  "aiAgent",
  "notifications",
  "announcements",
  "websiteVisitors",
  "team",
  "billing",
  "internalSso",
  "portal",
  "tiers",
  "integrations",
  "crmCopilot",
];

export const isCrmUser = (permissions: PrismaJson.TeamUserRolePermissions) => {
  return permissions?.isCrmUser === true;
};

export const hasPermission = (
  permissions: PrismaJson.TeamUserRolePermissions,
  permission: keyof PrismaJson.TeamUserRolePermissions
) => {
  if (permissions?.["has_all_permissions"] === true) return true;
  return !!permissions[permission];
};
